module.exports = __webpack_public_path__ + "img/profsalon.9640ef9b.png";